import { ApiClient } from './Api';
import { ApiModules } from './ApiModules'; // Import the interface
import ErrorHandler from './services/ErrorHandler';

/**
 * A cache to store instantiated API modules.
 */
const apiModules = new Map<keyof ApiModules, any>();

/**
 * Retrieves or creates an API module instance based on the specified module name.
 * 
 * @param {T} module - The module name, which should match one of the keys in the ApiModules interface.
 * @param {ApiClient} apiClient - The ApiClient instance to be passed to the API module constructor.
 * @returns {ApiModules[T]} An instance of the requested API module.
 */
async function getApiModule<T extends keyof ApiModules>(module: T, apiClient: ApiClient): Promise<ApiModules[T]> {
    if (!apiModules.has(module)) {
        try {
            const moduleFile = await import(`./modules/${module}`);
            const Module = moduleFile[module];
            apiModules.set(module, Module(apiClient)); 
      } catch (error) {
          ErrorHandler.logError(new Error(`Failed to load module ${module}:`));
          throw new Error(`Module ${module} cannot be loaded`);
      }
  }
  return apiModules.get(module);
}


export { getApiModule };